import { TableColumn } from '@shared/interfaces';

/**
 * The columns for the screens table.
 */
export const SCREENS_COLUMNS: TableColumn[] = [
    { field: 'screenName', header: 'Screen Name', width: '250px', hasRedirect: true },
    { field: 'dealer', header: 'Dealer', width: '180px', hasRedirect: true },
    { field: 'host', header: 'Host', width: '180px' },
    { field: 'type', header: 'Type', width: '120px' },
    { field: 'template', header: 'Template', width: '180px' },
    { field: 'creationDate', header: 'Creation Date', width: '180px' },
    { field: 'createdBy', header: 'Created By', width: '180px' },
    {
        field: 'actions',
        header: 'Actions',
        width: '120px',
        type: 'actions',
        actions: [{ icon: 'delete', name: 'delete', color: '#FF4D4F' }],
    },
];

/**
 * Dummy screens data matching the table columns from the screenshot.
 */
export const SCREENS_DATA = [
    {
        id: '1',
        screenName: 'Lorem Tag',
        dealer: 'Lorem Alias',
        host: 'Me i am',
        type: 'Ad',
        template: 'NCT Standard',
        creationDate: 'Month, Day, Year',
        createdBy: 'Me i am',
    },
    {
        id: '2',
        screenName: 'Lorem Tag',
        dealer: 'Lorem Alias',
        host: 'Me i am',
        type: 'Ad',
        template: 'NCT Standard',
        creationDate: 'Month, Day, Year',
        createdBy: 'Me i am',
    },
    {
        id: '3',
        screenName: 'Lorem Tag',
        dealer: 'Lorem Alias',
        host: 'Me i am',
        type: 'Ad',
        template: 'NCT Standard',
        creationDate: 'Month, Day, Year',
        createdBy: 'Me i am',
    },
    {
        id: '4',
        screenName: 'Lorem Tag',
        dealer: 'Lorem Alias',
        host: 'Me i am',
        type: 'Ad',
        template: 'NCT Standard',
        creationDate: 'Month, Day, Year',
        createdBy: 'Me i am',
    },
    {
        id: '5',
        screenName: 'Lorem Tag',
        dealer: 'Lorem Alias',
        host: 'Me i am',
        type: 'Ad',
        template: 'NCT Standard',
        creationDate: 'Month, Day, Year',
        createdBy: 'Me i am',
    },
    {
        id: '6',
        screenName: 'Lorem Tag',
        dealer: 'Lorem Alias',
        host: 'Me i am',
        type: 'Ad',
        template: 'NCT Standard',
        creationDate: 'Month, Day, Year',
        createdBy: 'Me i am',
    },
    {
        id: '7',
        screenName: 'Lorem Tag',
        dealer: 'Lorem Alias',
        host: 'Me i am',
        type: 'Ad',
        template: 'NCT Standard',
        creationDate: 'Month, Day, Year',
        createdBy: 'Me i am',
    },
    {
        id: '8',
        screenName: 'Lorem Tag',
        dealer: 'Lorem Alias',
        host: 'Me i am',
        type: 'Ad',
        template: 'NCT Standard',
        creationDate: 'Month, Day, Year',
        createdBy: 'Me i am',
    },
    {
        id: '9',
        screenName: 'Lorem Tag',
        dealer: 'Lorem Alias',
        host: 'Me i am',
        type: 'Ad',
        template: 'NCT Standard',
        creationDate: 'Month, Day, Year',
        createdBy: 'Me i am',
    },
];
